import TrainingPlansDrawer from "@Components/training-plans/training-plans-drawer/training-plans-drawer";
import TrainingPlansSnackbar from "@Components/training-plans/training-plans-snackbar";
import { useTrainingPlansOnboardingGate } from "@hooks/game/training-plans/use-training-plans-onboarding-gate";
import { useTrainingPlansToast } from "@hooks/game/training-plans/use-training-plans-toast";

const TrainingPlansService = () => {
  useTrainingPlansOnboardingGate();

  const { hideToast, toast } = useTrainingPlansToast();

  return (
    <>
      <TrainingPlansDrawer />
      <TrainingPlansSnackbar isComplete={toast.isComplete} message={toast.message} open={toast.open} title={toast.title} onClose={hideToast} />
    </>
  );
};

export default TrainingPlansService;
